import { render } from "./confirmOtpPhone.vue?vue&type=template&id=6c6879c1"
import script from "./confirmOtpPhone.vue?vue&type=script&lang=js"
export * from "./confirmOtpPhone.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__